import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiAuth, setToken, getToken } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [guest, setGuest] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const me = await apiAuth.me();
      setUser(me);
      setGuest(false);
      return me;
    } catch {
      setToken(null);
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Listen for guest flag
    try {
      const isGuest = sessionStorage.getItem("grabb_guest") === "1";
      if (isGuest) setGuest(true);
    } catch {}
  }, [refresh]);

  const signIn = (token, userObj) => {
    setToken(token);
    setUser(userObj);
    setGuest(false);
    sessionStorage.removeItem("grabb_guest");
  };

  const enterGuest = () => {
    setGuest(true);
    setUser(null);
    setToken(null);
    sessionStorage.setItem("grabb_guest", "1");
  };

  const signOut = async () => {
    try { await apiAuth.logout(); } catch {}
    setToken(null);
    setUser(null);
    setGuest(false);
    sessionStorage.removeItem("grabb_guest");
  };

  return (
    <AuthCtx.Provider value={{ user, guest, loading, signIn, signOut, enterGuest, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
